import { Injectable, inject } from '@angular/core';
import { ApiUrlBuilder } from '../builders/api-url.builder';
import { HttpParams } from '../enums/http-params';
import { HttpQueryParams } from '../enums/http-query-params';

@Injectable({
  providedIn: 'root',
})
export class HttpUrlFactory {
  private readonly builder = inject(ApiUrlBuilder);

  public simple(host: string, path: string): string {
    return this.builder.host(host).path(path).build();
  }

  public withParams(
    host: string,
    path: string,
    params: { [key in HttpParams]?: string },
  ): string {
    return this.builder.host(host).path(path).params(params).build();
  }

  public withQueryParams(
    host: string,
    path: string,
    queryParams: { [key in HttpQueryParams]?: string },
  ): string {
    return this.builder.host(host).path(path).queryParams(queryParams).build();
  }

  public complex(factory: (builder: ApiUrlBuilder) => string): string {
    return factory(this.builder);
  }
}
